import React, { useState } from 'react'
import LOGO from '../Assets/large.png'
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const NavLink = ({ href, children }) => (
    <a href={href} className="text-gray-700 hover:text-amber-600 block px-4 py-2">{children}</a>
);
         return (
             <nav className="bg-white shadow-md sticky top-0 z-50 h-[90px]"> 
                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                     <div className="flex justify-between items-center h-16">
                         <div className="flex-shrink-0">
                             <img src={LOGO} className="w-full h-24 object-cover gallery-img" style={{marginTop:"10px"}}/>
                         </div>
                         <div className="hidden md:flex space-x-8  items-center text-purple-400">
                             <NavLink href="#necklaces">Necklaces</NavLink>
                             <NavLink href="#bracelets">Bracelets</NavLink>
                             <NavLink href="#earrings">Earrings</NavLink>
                             <NavLink href="#gallery">Gallery</NavLink>
                         </div>
                         <div className="md:hidden">
                             <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 focus:outline-none">
                                 <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}/>
                                 </svg>
                             </button>
                         </div>
                     </div>
                 </div>
                 {isOpen && (
                     <div className="md:hidden bg-white px-4 pt-2 pb-4">
                         <NavLink href="#necklaces">Necklaces</NavLink>
                         <NavLink href="#bracelets">Bracelets</NavLink>
                         <NavLink href="#earrings">Earrings</NavLink>
                         <NavLink href="#gallery">Gallery</NavLink>
                     </div>
                 )}
             </nav>
  )
}

export default Navbar